module.exports = __webpack_public_path__ + "img/ronnie-flex-thumb.a0e8d01f.jpg";